const addToCartMessage = () => {
    const copyButtons = document.querySelectorAll('[data-copy]');
    copyButtons.forEach((button) => {
        button.addEventListener('click', () => {
            button.classList.add('add-to-cart-message__copy-button--active');
            const buttonText = button.querySelector('[data-copy-text]');
            const toolTip = button.querySelector('[data-copy-tooltop]');
            const copyString = button.getAttribute('data-copy-content');
            if (copyString) {
                buttonText.innerHTML = window.threadheads.copyButtonCopied;
                toolTip.innerHTML = 'Copied: ' + copyString;
                navigator.clipboard.writeText(copyString);
                setTimeout(() => {
                    button.classList.remove('add-to-cart-message__copy-button--active');
                    buttonText.innerHTML = window.threadheads.copyButton;
                }, 2500);
            }
        });
        button.addEventListener('mouseout', () => {
            const toolTip = button.querySelector('[data-copy-tooltop]');
            setTimeout(() => {
                toolTip.innerHTML = window.threadheads.copyButtonTooltip;
            }, 300);
        });
    });
};
export { addToCartMessage };
